import { useEffect } from 'react';

import { shallowEqual } from 'react-redux';

import { EDITOR_TOP, EDITOR_WIDTH } from './const';
import { EditorPopup } from './EditorPopup';
import { EditorWrapper } from './EditorWrapper';
import { CSSEditorPortal } from './style';
import { WidgetEditor } from 'jamespot-front-business';

import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '../../redux/store';

export const CSSEditorPortalWrapper = styled.div`
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 1;
`;

export const CSSEditorPortalPopupWrapper = styled.div<{ isActive: boolean }>`
    flex: 1;
    display: flex;
    margin-top: ${EDITOR_TOP}px;
    pointer-events: ${(props) => (props.isActive ? 'all' : 'none')};
`;

export const CSSEditorPortalRow = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    pointer-events: none;
`;

export const CSSEditorPortalFreeSpace = styled.div`
    width: ${EDITOR_WIDTH}px;
    pointer-events: none;
`;

/*
    Editors wrapper (template)
*/
export const EditorsPortal = () => {
    const dispatch = useAppDispatch();
    useEffect(() => {
        const flush = () => {
            dispatch(WidgetEditor.slice.actions.flushAllEditor());
        };

        window.addEventListener('NGWidgetEditorFlushAll', flush);
        return () => {
            window.removeEventListener('NGWidgetEditorFlushAll', flush);
        };
    }, [dispatch]);

    const editors = useAppSelector(WidgetEditor.selectors.selectEditors, shallowEqual);

    return (
        <CSSEditorPortalWrapper className="editor-portal-wrapper">
            {editors.map((editor) => {
                return (
                    <CSSEditorPortal isActive={false} key={editor.uniqid}>
                        <CSSEditorPortalRow>
                            {editor.position === 'left' ? (
                                <>
                                    <EditorWrapper uniqid={editor.uniqid} position={editor.position}></EditorWrapper>
                                    <CSSEditorPortalPopupWrapper isActive={editor.popup !== undefined}>
                                        <EditorPopup uniqid={editor.uniqid} />
                                    </CSSEditorPortalPopupWrapper>
                                    <CSSEditorPortalFreeSpace />
                                </>
                            ) : (
                                <>
                                    <CSSEditorPortalFreeSpace />
                                    <CSSEditorPortalPopupWrapper isActive={editor.popup !== undefined}>
                                        <EditorPopup uniqid={editor.uniqid} />
                                    </CSSEditorPortalPopupWrapper>
                                    <EditorWrapper uniqid={editor.uniqid} position={editor.position}></EditorWrapper>
                                </>
                            )}
                        </CSSEditorPortalRow>
                    </CSSEditorPortal>
                );
            })}
        </CSSEditorPortalWrapper>
    );
};
